<script lang="ts">
	import { Snapshot } from "luxedo-data"
	import SnapshotSelector from "../snapshot-select/SnapshotSelector.svelte"
	import { SnapshotModifierController } from "./SnapshotModifierController.svelte"
	import { getContext } from "svelte"
	import { Responsive } from "responsive"

	let controller = getContext<SnapshotModifierController>("controller")
	let snapshots = $derived(controller.availableSnapshots)
	let selectedSnapshot: Snapshot = $derived(controller.selectedSnapshot)

	let isMobile = $derived(Responsive.isMobile)
</script>

<div class="selector-step" class:isMobile>
	<div class="heading">
		<h3>Select your Snapshot</h3>
		<p class="info">
			Choose the snapshot that best represents your projection environment (and your device's
			current location). This will serve as the foundation for mapping themed content to your space.
		</p>
	</div>

	<SnapshotSelector
		snapshotIds={snapshots.map((snap) => snap.id)}
		selectedSnapshotId={selectedSnapshot?.id}
		onselect={controller.selectSnapshot}
	/>
	<div class="button-container">
		<button class="link-button" onclick={() => controller.cancel()}>Cancel</button>
		<button onclick={() => controller.setView("mask")}>Next</button>
	</div>
</div>

<style>
	.selector-step {
		display: flex;
		flex-direction: column;
		overflow: hidden;
		height: 100%;
	}

	.button-container {
		padding: 1rem;
		margin: 0;
		justify-content: flex-end;
	}

	.heading {
		padding: 1rem;
	}

	.info {
		margin-bottom: 0;
		line-height: 1.2em;
		color: var(--color-text);
	}

	.isMobile .info {
		text-align: center;
	}

	.link-button {
		padding-right: 1rem;
	}
</style>
